import React from 'react';
import { observable, decorate, computed } from 'mobx';
import _ from 'lodash';
import moment from 'moment-timezone';
import { checkRights, collectCheckBox, formatDate, getRandomRangeValue } from '../functions';
import { authUserState, uistate } from './common';
import { InvoiceTypes } from './invoices';

const JournalsInfo = [
	{
		Id : 1, // Фритюр
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3.6.1079-01. Журнал должен вестись на всех предприятиях, где присутствует фритюрная продукция. Журнал должен заполняться ежедневно, до начала и после окончания жарки.",
		InstructionsSet : [
			null,
			"В качестве предварительной настройки, перечислите фритюрные жиры, которые вы используете на производстве в указанном филиале",
			null, 
			"Здесь нужно указать модели используемых фритюрниц",
		],
		FillingTemplate : {
			Desktop : "150px 20% auto 20% 20% 25px",
			Tablet : "150px 40% auto 25px"
		},
		ReportTemplate : {
			Desktop : "120px 7% 125px 7% auto 120px 125px 105px 105px 150px",
			Device : "120px 100px 125px 100px 150px 120px 125px 105px 120px 150px"
		}
	},
	{
		Id : 2, // Здоровья
		Behaviors : {
			Workers : { Date : 0, Worker : 1 },
			ReportGroupByDate : true
		},
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.4.5.2409-08. Журнал должен заполняться ежедневно, по мере прихода сотрудников на предприятие",
		InstructionsSet : [
			null,
			"Заполните список сотрудников, которые работают на данном предприятии",
			"Укажите должности, в которых работают перечисленные сотрудники"
		],
		FillingTemplate : {
			Desktop : "100px 25% 15% 80px 130px auto 25px",
			Tablet : "100px auto 25% 20% 25px"
		},
		ReportTemplate : {
			Desktop : "150px auto 150px 100px 100px 150px 250px",
			Device : "90px 150px 90px 90px 90px 150px 200px"
		}
	},
	{
		Id : 202, // Здоровья
		Behaviors : {
			Workers : { Date : 0, Worker : 1 },
			ReportGroupByDate : true
		},
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.4.5.2409-08. Журнал должен заполняться ежедневно, по мере прихода сотрудников на предприятие",
		InstructionsSet : [
			null,
			"Заполните список сотрудников, которые работают на данном предприятии",
			"Укажите должности, в которых работают перечисленные сотрудники"
		],
		FillingTemplate : {
			Desktop : "100px 25% 15% 80px 130px auto 25px",
			Tablet : "130px auto 25% 20% 25px"
		},
		ReportTemplate : {
			Desktop : "150px auto 150px 100px 100px 150px 250px",
			Device : "90px 150px 90px 90px 90px 150px 200px"
		}
	},
	{
		Id : 3, // Холодильники
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 3.3686-21. Журнал заполняется дважды в день, температурные данные заносятся в 9 утра и в 17 часов после полудня",
		InstructionsSet : [
			null,
			"Для формирования журнала, перечислите все используемое холодильное и морозильное оборудование, с указанием помещения, где оно находится"
		],
		FillingTemplate : {
			Desktop : "150px auto 140px 25px"
		},
		ReportTemplate : {
			Desktop : "150px auto 170px 250px"
		}
	},
	{
		Id : 4, // Влажность
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3/2.4.3590-20. Журнал заполняется по каждому складскому помещению, дважды в день — утром, до начала работы, и вечером, по окончанию работы",
		InstructionsSet : [
			null, 
			"Для настройки журнала, перечислите складские помещения в вашем предприятии"
		],
		FillingTemplate : {
			Desktop : "150px auto 140px 140px 25px"
		},
		ReportTemplate : {
			Desktop : "150px auto 170px 170px  250px",
			Device : "120px auto 110px 100px 190px"
		}
	},
	{
		Id : 5, // Бракераж
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3.6.1079-01. Журнал заполняется один раз в день, перед отпуском продукции.",
		InstructionsSet : [
			null,
			null,
			(hasERP) => hasERP
				? "Для настройки данного поля можно использовать собственный список значений или продукцию из подключенной ERP. Если выбрать продукцию из ERP, при заполнении журнала пользователь сможет выбирать позиции из настроенного справочника продукции."
				: "Укажите список готовой продукции для бракеража. Эти значения будут доступны пользователю при заполнении журнала."
		],
		FillingTemplate : {
			Desktop : "200px 260px auto 30px",
			Tablet : "150px 120px auto 25px"
		},
		ReportTemplate : {
			Desktop : "150px 90px auto 120px 120px 120px 250px",
			Device : "130px 90px 150px 130px 100px 120px 190px"
		}
	},
	{
		Id : 6, // Вентиляция
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3.6.1079-01. Журнал заполняется по факту проведения работ.",
		InstructionsSet : [],
		FillingTemplate : {
			Desktop : "100px auto 40% 210px 25px"
		},
		ReportTemplate : {
			Desktop : "100px auto 20% 210px 250px",
			Device : "90px 170px 150px 150px 200px"
		}
	},
	{
		Id : 7, // Выдачи дез средств
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3.6.1079-01. Журнал заполняется ежедневно при проведении всех типов уборок.",
		InstructionsSet : [
			null,
			"Перечислите обрабатываемые помещения",
			"Укажите способ обработки помещений",
			null,
			"Укажите используемое дез. средство"
		],
		FillingTemplate : {
			Desktop : "130px auto 190px 150px auto 25px",
			Tablet : "130px 170px auto 150px 25px"
		},
		ReportTemplate : {
			Desktop : "80px auto 120px 80px auto 100px 90px 90px 80px 200px"
		}
	},
	{
		Id : 8, // Бактерицидка
		Behaviors : { GroupJournals : true },
		RemainingWorkLimits : { Warning : 150 * 60, Critical : 50 * 60 },
		Description : "Журнал составляется на каждую установку. Журнал заполняется по каждому включению бактерицидной лампы.",
		InstructionsSet : [
			null,
			null,
			"Укажите объект обеззараживания",
			"Укажите вид микроорганизмов, согласно техническим характеристикам модели",
			"Укажите длительность и режим облучения, исходя из кубатуры и технических характеристик модели бактерицидной установки. 'Непрерывный' в случае, если лампа работает на протяжении рабочего дня, 'повторно-кратковременный'  – при кратковременной обработке."
		],
		FillingTemplate : {
			Desktop : "200px 170px auto 200px 200px 25px",
			Tablet : "150px auto 215px 25px"
		},
		ReportTemplate : {
			Desktop : "80px 130px auto 180px 130px 80px 80px 80px 250px",
			Device : "80px 130px 120px 180px 130px 80px 80px 80px 250px"
		}
	},
	{
		Id : 9, // Ген уборки
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.1.3.2630-10. Генеральная уборка на предприятии должна проводиться не реже раза в месяц.",
		InstructionsSet : [],
		FillingTemplate : {
			Desktop : "120px auto 120px 25px"
		},
		ReportTemplate : {
			Desktop : "150px auto 150px 250px",
			Device : "120px auto 120px 200px"
		}
	},
	{
		Id : 184, // Журнал корректирующих действий
		Description : "Журнал используется для регистрации несоответствий в критических контрольных точках и принятых корректирующих действий в рамках процедур ХАССП. ТР ТС 021/2011 «О безопасности пищевой продукции».",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 29% 29% 25px" },
		ReportTemplate : { Desktop : "150px auto 25% 25% 250px" }
	},
	{
		Id : 185, // Журнал учёта температуры в толще продукции/ПФ после термической обработки
		Description : "Журнал используется для контроля температуры в толще продукции после термической обработки в рамках производственного контроля, основанного на принципах ХАССП. СанПиН 2.3/2.4.4282-26.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "150px auto 200px 25px" },
		ReportTemplate : { Desktop : "150px auto 170px 250px" }
	},
	{
		Id : 186, // Журнал учёта остаточного кислорода в упаковке после запайки в ГМС
		Description : "Журнал используется для контроля остаточного кислорода в упаковке продукции после запайки в газомодифицированной среде в рамках производственного контроля.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "150px auto 200px 25px" },
		ReportTemplate : { Desktop : "150px auto 170px 250px" }
	},
	{
		Id : 187, // Журнал учёта температуры в толще продукции/ПФ после охлаждения
		Description : "Журнал используется для контроля температуры в толще продукции после охлаждения в рамках производственного контроля, основанного на принципах ХАССП. СанПиН 2.3/2.4.4282-26.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "150px auto 200px 25px" },
		ReportTemplate : { Desktop : "150px auto 170px 250px" }
	},
	{
		Id : 188, // Журнал уборки прилегающей территории
		Description : "Журнал используется для планирования и фиксации уборки прилегающей территории. Позволяет учитывать планируемую и фактическую дату проведения уборки, а также способ уборки.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 120px 25px" },
		ReportTemplate : { Desktop : "150px auto 150px 250px" }
	},
	{
		Id : 189, // Ламповый журнал
		Behaviors : { GroupJournals : true },
		RemainingWorkLimits : { Warning : 500 * 60, Critical : 170 * 60 },
		Description: "Журнал используется для учета времени работы инсектицидных УФ-ламп и контроля остатка ресурса лампы. Журнал заполняется по факту включения и выключения лампы.",
		InstructionsSet : [],
		FillingTemplate : { 
			Desktop : "200px 150px 20% 20% auto 25px", 
			Tablet: "160px 100px 17% 17% auto 25px"
		},
		ReportTemplate : { Desktop : "150px 25% 25% auto 250px" }
	},
	{
		Id : 190, // Журнал претензий
		Description : "Журнал используется в рамках регистрационно-учетной документации системы ХАССП для фиксации рекламаций, претензий, жалоб и происшествий, связанных с нарушением требований безопасности продукции. Журнал заполняется по факту поступления претензии, жалобы или сообщения о происшествии.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px 35% auto 25px" },
		ReportTemplate : { Desktop : "90px 130px auto 100px 220px 220px 190px" }
	},
	{
		Id : 191, // Журнал дератизации и дезинсекции
		Description : "Журнал используется для фиксации мероприятий по дератизации и дезинсекции (СП 3.5.3.3223-14, СанПиН 3.5.2.3472-17). Журнал заполняется по факту проведения мероприятий.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px 20% auto 25% 25px" },
		ReportTemplate : { 
			Desktop : "150px auto 190px 250px 250px",
			Device: "90px auto 110px 160px 200px"
		}
	},
	{
		Id : 192, // Журнал мойки дезковриков
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал используется для фиксации санитарной обработки дезинфицирующих ковриков (МР 3.5.0353-24). Журнал заполняется по факту мероприятия.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 20% 20% 25px" },
		ReportTemplate : { 
			Desktop : "150px auto 190px 250px 250px",
			Device : "90px auto 90px 90px 200px"
		}
	},
	{
		Id : 193, // Ножи, ножницы
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал используется в рамках производственного контроля и процедур ХАССП для контроля физических опасных факторов. В журнале фиксируется наличие и целостность ножей, ножниц и прочих острых предметов, чтобы снизить риск попадания посторонних предметов в пищевую продукцию. Периодичность контроля устанавливается предприятием, на практике журнал может заполняться ежедневно или перед началом смены.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 15% 150px 25px" },
		ReportTemplate : { 
			Desktop : "150px auto 120px 150px 250px",
			Device: "90px auto 80px 110px 200px"
		}
	},
	{
		Id : 194, // Журнал сдачи и выдачи санитарной одежды на стирку
		Description : "Журнал используется для фиксации сдачи и выдачи санитарной одежды на стирку в рамках соблюдения санитарных требований к рабочей одежде сотрудников (СанПиН 2.3/2.4.3590-20). Журнал заполняется по факту.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 15% 15% 150px 25px" },
		ReportTemplate : { 
			Desktop : "150px auto 120px 150px 150px 250px",
			Device: "100px auto 70px 90px 90px 200px" 
		}
	},
	{
		Id : 195, // Журнал дефростации замороженной продукции
		Description : "Журнал используется в рамках производственного контроля и процедур ХАССП для фиксации процесса дефростации замороженной продукции и контроля условий подготовки продукции к производству.",
		InstructionsSet : [],
		FillingTemplate : { 
			Desktop : "140px auto 100px 80px 140px 80px 100px 25px",
			Tablet : "140px auto 100px 80px 25px" 
		},
		ReportTemplate : { Desktop : "130px auto 100px 100px 140px 100px 90px 230px" }
	},
	{
		Id : 196, // Журнал контроля отгружаемой готовой продукции
		Description : "Журнал используется в рамках производственного контроля и процедур ХАССП для фиксации контроля готовой продукции перед отгрузкой. Контроль нужен для проверки продукции, упаковки, условий хранения и готовности к передаче.",
		InstructionsSet : [
			null,
			(hasERP) => hasERP
				? "Для настройки данного поля можно использовать собственный список значений или продукцию из подключенной ERP. Если выбрать продукцию из ERP, при заполнении журнала пользователь сможет выбирать позиции из настроенного справочника продукции."
				: "Укажите список готовой продукции для бракеража. Эти значения будут доступны пользователю при заполнении журнала."
		],
		FillingTemplate : { Desktop : "150px auto 15% 25px" },
		ReportTemplate : { Desktop : "150px auto 100px 250px" }
	},
	{
		Id : 197, // Журнал очистки инсектицидных ламп
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал используется для фиксации очистки и контроля состояния инсектицидных ламп в рамках производственного контроля.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "120px auto 20% 120px 25px" },
		ReportTemplate : { 
			Desktop : "130px auto 20% 130px 250px",
			Device: "100px 200px 150px 90px 200px" 
		}
	},
	{
		Id : 198, // Журнал входного контроля сырья и материалов
		Behaviors : {
			Invoices : { Date : 0, Product : 1, Count : 2, Provider : 3, InvoiceNumber : 4 }
		},
		Description : "Журнал используется для регистрации результатов входного контроля поступающего сырья, пищевой продукции, упаковочных и вспомогательных материалов. В МР 5.1.0096-14 по организации процессов на основе принципов ХАССП в составе подтверждающих документов указаны журнал входного контроля или листы приемки с обязательной оценкой условий транспортирования и доставки сырья. Журнал заполняется при приемке каждой партии сырья и материалов.",
		InstructionsSet : [
			null,
			(hasERP) => hasERP
				? "Для настройки данного поля можно использовать собственный список значений или продукцию из подключенной ERP. Если выбрать продукцию из ERP, при заполнении журнала пользователь сможет выбирать позиции из настроенного справочника продукции."
				: "Укажите список поставляемого сырья. Эти значения будут доступны пользователю при заполнении журнала.",
			null,
			(hasERP) => hasERP
				? "Для настройки данного поля можно использовать собственный список значений или продукцию из подключенной ERP. При выборе «справочник ERP» пользователь сможет выбирать из списка ваших контрагентов"
				: "Перечислите поставщиков, которые поставляют сырье и материалы на предприятие."
		],
		FillingTemplate : { 
			Desktop : "150px auto 150px 25% 25px",
			Tablet: "130px auto 130px 25% 25px" 
		},
		ReportTemplate : { Desktop : "80px auto 80px 140px 90px 100px 90px 200px" }
	},
	{
		Id : 199, // Журнал выдачи дезсредств и СИЗ
		Description : "Журнал составлен согласно санитарных правил (СанПиН) 2.3.6.1079-01. Журнал заполняется ежедневно при проведении всех типов уборок.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "100px auto 15% 10% 10% 25px" },
		ReportTemplate : { 
			Desktop : "150px auto 170px 110px 110px 250px",
			Device: "90px 200px 100px 100px 70px 200px"
		}
	},
	{
		Id : 200, // Журнал контроля целостности металлических, пластиковых предметов и сита
		Behaviors : { ReportGroupByDate : true },
		Description : "Журнал используется в рамках производственного контроля и процедур ХАССП для контроля физических опасных факторов и снижения риска попадания посторонних предметов в пищевую продукцию. Журнал заполняется с периодичностью, установленной предприятием.",
		InstructionsSet : [],
		FillingTemplate : { 
			Desktop : "100px auto 170px 255px 25px",
			Tablet : "100px auto 170px 195px 25px" 

		},
		ReportTemplate : { 
			Desktop : "150px auto 170px 170px 250px",
			Device: "90px 200px 90px 120px 200px" 
		}
	},
	{
		Id : 201, // Санитарного состояния транспорта
		Description : "Журнал используется для фиксации контроля условий перевозки пищевой продукции и продовольственного сырья. СанПиН 2.3/2.4.3590-20 требует принимать пищевую продукцию при наличии маркировки и товаросопроводительной документации, а при нарушении условий и режима перевозки, отсутствии документов или маркировки продукция не принимается. Журнал заполняется при приемке продукции, доставленной транспортом.",
		InstructionsSet : [],
		FillingTemplate : { Desktop : "100px auto 10% 195px 145px 25px" },
		ReportTemplate : { 
			Desktop : "130px auto 100px 180px 140px 250px",
			Device: "90px 200px 100px 100px 90px 200px"
		}
	}
]

const ErpDictionaries = [
	{ Id : 1, Name : "Сырьё", Group : 1 },
	{ Id : 2, Name : "Полуфабрикаты", Group : 1 },
	{ Id : 3, Name : "Продукция", Group : 1 },
	{ Id : 4, Name : "Поставщики", Group : 2 },
	// { Id : 5, Name : "Клиенты", Group : 2 } // TODO: вернуть после подключения полного списка клиентов
];

/** Общие настройки типов полей санитарных журналов */
export const SanJournalFieldTypes = [
	{ Id : 1, Name : "Строка", CanChange : false, CanDefault : true, Description : "Ввод текста каждый раз при заполнении журнала" },
	{ Id : 2, Name : "Целое число", CanChange : false, CanDefault : true, Step : [1,10], Description : "Указываемое значение должно быть целым числом" },
	{ Id : 3, Name : "Дробное число", CanChange : false, CanDefault : true, Step : [0.01, 0.1, 1, 10], Description : "Указываемое значение может быть дробным числом" },
	{ Id : 4, Name : "Дата", CanChange : false, CanDefault : false, Description : "Дата в формате ДД.ММ.ГГГГ" },
	{ Id : 5, Name : "Время", CanChange : false, CanDefault : false, Description : "Время события в формате ЧЧ:ММ" },
	{ Id : 6, Name : "Дата и время", CanChange : false, CanDefault : false, Description : "Дата и время события" },
	{ Id : 7, Name : "Да/нет", CanChange : false, CanDefault : true, Description : "Выбор «да» или «нет»" },
	{ Id : 8, Name : "Справочник", CanChange : false, CanDefault : true, Description : "Список вариантов, при заполнении надо выбрать один из них" }, // написать понятно
	{ Id : 9, Name : "Значения для полного заполнения", CanChange : false, CanRange : false, Description : "Список значений, для каждого из которых нужно заполнить остальные строки" }, // написать понятно
	{ Id : 10, Name : "Вычисляемое значение", CanChange : false, CanRange : false, Description : "" }, // написать понятно
];

/** ---------- Класс настроек журналов ---------- */
export class SanJournalManageState {
	constructor() {
		this.Lists = [];
		this.Templates = [];
		this.UserList = [];

		this.Journal = undefined;

		this.BusinessTypes = [
			{ Id : 1, Name : "Общепит" },
		]

		this.IsSendRequest = false;
	}

	/** Право на настройку санитарных журналов */
	get CanManage() { return authUserState.User ? checkRights("SanitaryJournalsManage") : false; }

	/** Флаг наличия модуля ERP у авторизованного пользователя
	 * @returns {boolean} модуль ERP доступен
	 */
	get HasERP() { return Boolean(authUserState.User && authUserState.HasERP); }

	/** Формирование списка пользователей */
	get Users() {
		if (_.isEmpty(this.UserList)) return [];

		return _.map(this.UserList, (v) => { return { Id: v.Id, Name: v.FirstName + " " + v.LastName } });
	}

	/**
	 * Разбор списка журналов
	 * @param {object} data ответ от сервера
	 */
	setLists(data) {
		this.Lists = data.Success ? _.map(data.List, (item) => ({
			...item,
			Role: _.compact([item.Role, item.User]).join(", ")
		})) : [];
		this.IsSendRequest = true;
	}

	/**
	 * Разбор списка шаблонов санитарных журналов
	 * @param {object} data ответ от сервера
	 */
	setTemplates(data) { 
		this.Templates = data.Success ? _.map(data.List, (item) => {
			const business = _.find(this.BusinessTypes, { Id: item.Business });

			return {
				...item,
				Type: business ? business.Name : ""
			};
		}) : [];
	}

	/** Формирование списка столбцов в таблице */
	get ListColumns() {
		return {
			Name: {
				...(uistate.IsMobile ? {} : { width: 430 }),
				Cell: (row) => <span className="journalName">
					<span>{row.original.Name}</span>
					{row.original.AddName && <small className="comment addName">{row.original.AddName}</small>}
				</span>
			},
			...(!uistate.IsMobile ? {
				Role: { Header: "Ответственный" },
				Filial: {}
			} : {}),
			...(this.CanManage && uistate.isDevice ? { View: {} } : {}),
			...(this.CanManage && !uistate.isDevice ? {
				Edit: {},
				Copy: {},
				Remove: {}
			} : {})
		};
	}

	/** Формирование списка столбцов в таблице шаблонов */
	get TemplateColumns() {
		return {
			...(this.CanManage && uistate.isDevice ? { View: {} } : {}),
			...(this.CanManage && !uistate.isDevice ? { Copy: {} } : {}),
			Name: {},
			Type: { Header: "Подходит для", width: 200, filterable: false }
		};
	}

	/**
	 * Разбор выбранного сан журнала
	 * @param {object} data ответ от сервера
	 * @param {string} type тип операции
	 */
	setList(data, type) {
		if (!_.isUndefined(data)) {
			const journal = _.cloneDeep(data);

			this.Journal = new Journal(journal, type, this.HasERP);
		}
		else this.Journal = undefined;
		
		this.IsSendRequest = true;
	}
}
decorate(SanJournalManageState, {
	Lists: observable,
	Templates: observable,
	IsSendRequest: observable,
	UserList: observable,
	Filials: observable,
	Roles: observable,

	Journal: observable,

	ErrorCode: observable,
	CanManage: computed,
	HasERP: computed,
	Users: computed
});

/** Журнал */
class Journal {
	constructor(item, action, hasERP) {
		this.Id = action === "copy" ? -1 : item && item.Id ? item.Id : -1;
		this.Active = item && !_.isUndefined(item.Active) ? item.Active : true;
		this.Name = item && item.Name ? item.Name : "";
		this.RoleId = item && item.RoleId ? item.RoleId : -1;
		this.FilialId = item && item.FilialId ? item.FilialId : -1;
		this.UserId = item && item.UserId ? item.UserId : -1;
		this.TemplateType = item && item.TemplateType !== -1 ? item.TemplateType :
			item && item.TemplateType === -1 && action === "copy" ? item.Id : -1;
		this.AddName = item && item.AddName ? item.AddName : "";
		this.StartRemainingWorkHours = item && !_.isNil(item.StartRemainingWorkMinutes)
			? item.StartRemainingWorkMinutes / 60
			: "";
		
		this.Fields = [];

		if (item && item.Fields) _.each(item.Fields, (field, i) => {
			var instructions = this.JournalInfo ? this.JournalInfo.InstructionsSet : [],
				instruction = !_.isUndefined(instructions) && !_.isEmpty(instructions)
					&& !_.isUndefined(instructions[i]) && !_.isNull(instructions[i]) ? instructions[i] : "";
			if (_.isFunction(instruction)) instruction = instruction(hasERP);

			const calc = field.Calc,
				calcFields = calc && _.isArray(calc.FieldIds) ? _.map(calc.FieldIds, (fieldId) => {
					const fieldIndex = _.findIndex(item.Fields, { Id : fieldId }),
						sourceField = _.find(item.Fields, { Id : fieldId });

					if (_.isUndefined(sourceField)) return { Name : "", Id : null };
					return {
						Name : sourceField.Name,
						Id : this.Id < 0 ? -(fieldIndex + 1) : sourceField.Id
					};
				}) : [],
				defaultListIndex = this.Id < 0 && field.DefaultValue && _.isArray(field.List)
					? _.findIndex(field.List, { Id : field.DefaultValue.Value }) : -1,
				defaultValue = defaultListIndex >= 0 ? {
					...field.DefaultValue,
					Value : -(defaultListIndex + 1)
				} : field.DefaultValue;

			this.Fields.push(new Field({
				...field,
				Id : this.Id < 0 ? -(i+1) : field.Id,
				HasERP : hasERP,
				Instruction : instruction,
				DefaultValue : defaultValue,
				Calc : calc ? {
					Type : calc.Type,
					Fields : calcFields
				} : undefined
			}))
		});


		this.Description = this.JournalInfo ? this.JournalInfo.Description : "";

		this.ErrorCode = "";
		this.ButtonLoading = false;
		this.SuccessSave = false;
	}

	get JournalInfo () { return this.TemplateType ? _.find(JournalsInfo, { Id : this.TemplateType }) : undefined }

	/** Признак журнала бактерицидной установки */
	get IsLampJournal() { return this.TemplateType === 8 || this.TemplateType === 189; }

	/** Отображение сообщения об успешном сохранении в течение трёх секунд */
	showSuccess() {
		this.ErrorCode = "SUCCESS_SAVE";
		this.SuccessSave = true;

		setTimeout(() => {
			this.ErrorCode = "";
			this.SuccessSave = false;
		}, 3000);
	}

	/**
	 * Сбор основных данных журнала с формы
	 * @param {string} id название поля
	 * @param {string} value значение поля
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Валидация формы настройки журнала перед сохранением
	 * 1. Филиал должен быть заполнен
	 * 2. Должен быть выбран отвественный — по должности или конкретный пользователь
	 * 3. В собственных справочниках должен быть заполнен хотя бы один пункт
	 * 4. Для ERP-справочника должен быть выбран хотя бы один допустимый целочисленный ID
	 * 5. В ERP-справочнике можно совместно выбирать только типы 1–3 либо только типы 4–5
	 * 6. Если выбрано дефолтное значение для типа поля 7 — оно должно быть bool
	 * 7. Если выбрано дефолтное значение для типа поля 2 и 3 — оно должно быть числом
	 * 8. Если выбрано дефолтное значение для типа поля 2 и 3 и выбран диапазон — должны быть заполнены все поля
	 * 9. Если выбрано дефолтное значение для типа поля 2 и 3 и выбран диапазон — min должен быть меньше max
	 * 10. Если выбрано дефолтное значение для типа поля 8 - оно должно быть числом и существовать в справочнике
	 * 11. Для журнала бактерицидной установки должно быть заполнено дополнительное название
	 * 12. Для журнала бактерицидной установки начальное оставшееся время работы должно быть строго положительным числом
	 * 13. В шаблоне должно быть ровно одно поле, отмеченное как дата отчёта
	 * 14. Датой отчёта может быть только поле типа 4 «Дата» или 6 «Дата и время»
	 * 15. Для поля типа 10 должны быть заданы настройки Calc типа 1 с двумя разными существующими полями
	 * @returns {boolean}
	 */
	validate() {
		this.ErrorCode = "";
		this.SuccessSave = false;

		var isValid = true;

		if (this.FilialId < 1 || this.FilialId === "") {
			this.ErrorCode = "FILIAL_REQUIRED";
			return false;
		}

		if ((this.RoleId < 1 || this.RoleId === "") && (this.UserId < 1 || this.UserId === "")) {
			this.ErrorCode = "RESPONSIBLE_REQUIRED";
			return false;
		}

		if (this.IsLampJournal && _.trim(this.AddName) === "") {
			this.ErrorCode = "WRONG_ADD_NAME";
			return false;
		}

		if (this.IsLampJournal && (!_.isFinite(this.StartRemainingWorkHours) || this.StartRemainingWorkHours <= 0)) {
			this.ErrorCode = "WRONG_START_REMAINING_WORK_MINUTES";
			return false;
		}

		var dateReport = _.filter(this.Fields, { IsReportDate : true })
		if (dateReport.length !== 1) {
			this.ErrorCode = "WRONG_REPORT_DATE";
			return false;
		}
		if (_.indexOf([4,6], dateReport[0].Type) === -1) {
			this.ErrorCode = "WRONG_REPORT_DATE";
			return false;
		}

		_.each(this.Fields, (field) => {
			if (field.IsList && !field.ListType && _.isEmpty(field.FilledList)) {
				this.ErrorCode = "SJFIELDLIST_REQUIRED";
				isValid = false;
				return false;
			}

			if (field.ListType) {
				const dictionaries = _.map(field.ErpDictionary, (id) => _.find(field.ErpDictionaries, { Id : id }));
				const groups = _.uniq(_.map(_.compact(dictionaries), "Group"));

				if (_.isEmpty(field.ErpDictionary) ||
					!_.every(field.ErpDictionary, _.isInteger) ||
					dictionaries.length !== _.compact(dictionaries).length || groups.length !== 1) {
					this.ErrorCode = "WRONG_ERP_DICTIONARY";
					isValid = false;
					return false;
				}
			}

			if (field.Type === 7 && !_.isBoolean(field.Value)) {
				this.ErrorCode = "WRONG_DEF_VALUE";
				isValid = false;
				return false;
			}

			if (_.indexOf([2,3], field.Type) !== -1 && field.Value && field.Value !== "" && !_.isNumber(field.Value)) {
				this.ErrorCode = "WRONG_DEF_VALUE";
				isValid = false;
				return false;
			}

			const range = [field.Min, field.Max, field.Step],
				isEmptyRange = _.every(range, (value) => value === "" || _.isNull(value) || _.isUndefined(value)),
				isFilledRange = _.every(range, (value) => value !== "" && !_.isNull(value) &&
					!_.isUndefined(value) && Number.isFinite(Number(value)));

			if (field.Range && !isEmptyRange && !isFilledRange) {
				this.ErrorCode = "EMPTY_DEF_RANGE";
				isValid = false;
				return false;
			}

			if (field.Range && (field.Min + field.Max + field.Step) !== "" && field.Min >= field.Max) {
				this.ErrorCode = "WRONG_DEF_RANGE"
				isValid = false;
				return false;
			}

			if (field.Type === 8 && field.Value !== "" &&
				(!_.isNumber(field.Value) || !_.find(field.FilledList, { Id : field.Value }))) {
				this.ErrorCode = "WRONG_DEF_VALUE";
				isValid = false;
				return false;
			}

			if (field.Type === 10) {
				if (_.isUndefined(field.Calc) || _.isNull(field.Calc)) {
					this.ErrorCode = "WRONG_CALC_SETTINGS";
					isValid = false;
					return false;
				}

				if (field.Calc.Type !== 1) {
					this.ErrorCode = "WRONG_CALC_SETTINGS";
					isValid = false;
					return false;
				}

				if (field.Calc.Fields.length !== 2 ||
					_.uniqBy(field.Calc.Fields, "Id").length !== 2 ||
					!_.every(field.Calc.Fields, (calcField) => _.some(this.Fields, { Id : calcField.Id }))) {
					this.ErrorCode = "WRONG_CALC_SETTINGS";
					isValid = false;
					return false;
				}
			}
		})

		return isValid;
	}

	/**
	 * Сбор данных с формы для отправки на сервер
	 * @returns {{ Id : number, Name : string, FilialId : number, RoleId : number, UserId : number, TemplateType : number, AddName? : string, StartRemainingWorkMinutes? : number, Fields : [object] }}
	 */
	getData() {
		var data = {
			Id : this.Id,
			Name : this.Name,
			FilialId : this.FilialId,
			RoleId : this.RoleId,
			UserId : this.UserId,
			TemplateType : this.TemplateType,
			...(this.IsLampJournal ? {
				AddName : this.AddName,
				StartRemainingWorkMinutes : this.StartRemainingWorkHours * 60
			} : {}),
			Fields : _.map(this.Fields, (field) => field.getData())
		}

		return data;
	}

}
decorate(Journal, {
	Id 			: observable, // ID журнала
	Name		: observable, // Название журнала
	FilialId	: observable, // ID филиала, к которому относится журнал
	RoleId		: observable, // ID должности, ответственного за заполнение
	UserId		: observable, // ID пользователя, 
	ExportType	: observable, // Тип выгрузки журнала в ПДФ
	Active		: observable, // Флаг актиновсти журнала
	Fields		: observable, // Поля шаблона журнала
	TemplateType : observable, // Тип шаблона
	AddName		: observable, // Дополнительное название журнала
	StartRemainingWorkHours: observable, // Начальный остаток работы установки в часах

	ErrorCode	: observable,
	ButtonLoading	: observable,
	SuccessSave		: observable,

	IsLampJournal	: computed
});

/** Поле */
class Field {
	
	/**
	 * Создание элемента поля
	 * @param {{ Id : number, Name : string, Type : number, Instruction: string, DefaultValue : object, List : [object]}} item элемент поля
	 * @param {string} action тип добавления «copy» для копирования
	 */
	constructor(item) {
		this.Id = item && item.Id ? item.Id : -1;
		this.Name = item && item.Name ? item.Name : "";
		this.Type = item && item.Type ? item.Type : 1;
		this.TypeTitle = "";
		this.Description = "";
		this.Instruction = item && item.Instruction ? item.Instruction : "";
		this.HasERP = item && item.HasERP ? item.HasERP : false;
		this.ErpDictionary = item && _.isArray(item.ErpDictionary) ? item.ErpDictionary : [];
		this.ListType = !_.isEmpty(this.ErpDictionary);
		this.IsReportDate = item && !_.isUndefined(item.IsReportDate) ? item.IsReportDate : false;

		this.Calc = item && item.Calc ? item.Calc : undefined;

		this.Value = item && item.DefaultValue ? item.DefaultValue.Value : this.Type === 7 ? false : "";
		this.Min = item && item.DefaultValue ? item.DefaultValue.Min : "";
		this.Max = item && item.DefaultValue ? item.DefaultValue.Max : "";
		this.Step = item && item.DefaultValue && item.DefaultValue.Step && !_.isNull(item.DefaultValue.Step) ? item.DefaultValue.Step.toString() : "";

		this.Steps = undefined;
		this.Range = item && item.DefaultValue && item.DefaultValue.Min && !_.isNull(item.DefaultValue.Min) ? true : false;
		
		var type = this.TypeSettings;
		if (!_.isUndefined(type)) {
			this.Description = type.Description;

			this.Steps = type.Step ? _.map(type.Step, (v) => { return { Id : v.toString(), Name : v }; }) : undefined;
			this.CanDefault = type.CanDefault;

			if (!type.CanChange) this.TypeTitle = type.Name;
		}
		
		this.List = [];
		if (this.IsList) {
			if (item && item.List && !_.isEmpty(item.List) && !_.isNull(item.List))
				_.each(item.List, (value, i) => {
					this.List.push(new ListItem({ Id : this.Id < 0 ? -(i + 1) : value.Id, Value : value.Value }));
				});
			else  this.List.push(new ListItem());
		}
	}

	/** Признак поля со значениями собственного справочника */
	get IsList() { return this.Type === 8 || this.Type === 9; }
	/** Настройки текущего типа поля */
	get TypeSettings() { return _.find(SanJournalFieldTypes, { Id : this.Type }); }
	/** Признак показа настроек ERP-справочника для нового списка или сохранённого ERP-поля */
	get ShowERPSettings() {
		return this.HasERP && ((this.Id < 0 && this.IsList) || (this.Id > 0 && this.Type === 1 && this.ListType));
	}
	/** Признак возможности переключать новый список между собственным и ERP-справочником */
	get CanChangeListType() { return this.Id < 0 && this.IsList; }
	/** Признак доступности настройки значения по умолчанию только для полей без ERP-справочника */
	get CanSetDefault() { return this.CanDefault && !this.ListType; }
	/** Признак числового поля */
	get IsNumber() { return this.Type === 2 || this.Type === 3; }
	/** Признак логического поля */
	get IsBoolean() { return this.Type === 7; }
	/** Список доступных справочников ERP с группами совместимости */
	get ErpDictionaries() { return ErpDictionaries; }
	/** Заполненные строки справочника для валидации и отправки на сервер */
	get FilledList() { return _.compact(_.map(this.List, (item) => item.getData())); }

	get CalcTitle () {
		if (_.isUndefined(this.Calc)) return "";
		var title = "";

		if (this.Calc.Type === 1) title = "Разница в минутах между "
		title += _.map(this.Calc.Fields, (field) => `[${field.Name}]`).join(" и ");

		return title;
	}

	/** Добавление строки справочника со следующим свободным отрицательным ID */
	addListItem() {
		const ids = _.map(_.filter(this.List, (item) => item.Id < 0), "Id");
		const id = _.isEmpty(ids) ? -1 : _.min(ids) - 1;
		this.List.push(new ListItem({ Id : id }));
	}

	/**
	 * Удаление строки справочника
	 * @param {number} index индекс строки
	 */
	deleteListItem(index) { this.List = _.filter(this.List, (item, i) => i !== index); }

	/**
	 * Сбор настроек поля с формы
	 * @param {string} id название настройки
	 * @param {string|number|boolean} value значение настройки
	 * @param {number} index индекс строки справочника для дефолтного значения
	 */
	collect(id, value, index) {
		if (/IsDefault/.test(id)) this.Value = value ? this.List[index].Id : "";
		else this[id] = value;
	}

	/**
	 * Сбор настроек поля для отправки на сервер
	 * @returns {{ Id : number, Name : string, Type : number, List : [object], ErpDictionary : [number]|null, DefaultValue : object|null, Calc : object|null, IsReportDate : boolean }}
	 */
	getData() {
		return {
			Id : this.Id,
			Name : this.Name,
			Type : this.ListType && this.Id < 0 ? 1 : this.Type,
			List : this.FilledList,
			ErpDictionary : this.ListType ? this.ErpDictionary : null,
			DefaultValue : !this.CanSetDefault ? null : {
				Value : !this.Range && this.Value !== "" ? this.Value : null,
				Min : this.Range && this.Min !== "" ? this.Min : null,
				Max : this.Range && this.Max !== "" ? this.Max : null,
				Step : this.Step !== "" ? parseFloat(this.Step) : null
			},
			Calc : !_.isUndefined(this.Calc) ? {
				Type : this.Calc.Type,
				FieldIds : _.map(this.Calc.Fields, "Id")
			} : null,
			IsReportDate : this.IsReportDate
		};
	}
}
decorate(Field, {
	Id		: observable, // ID поля шаблона
	Name	: observable, // Название поля шаблона
	Type	: observable, // Тип данных поля
	List	: observable, // Значения справочника
	
	Value	: observable, // Значение по умолчанию
	Min		: observable, // Мин значение по умолчанию
	Max		: observable, // Макс значение по умолчанию
	Step	: observable, // Точность значения по умолчанию
	Range	: observable, // Флаг значения/диапазона значений
	ListType: observable, // Флаг типа справочника
	ErpDictionary: observable, // Справочник ERP
	Calc: observable, // Настройки вычисляемого поля

	IsList	: computed,
	TypeSettings: computed,
	ShowERPSettings: computed,
	CanChangeListType: computed,
	CanSetDefault: computed,
	IsNumber: computed,
	IsBoolean: computed,
	FilledList: computed,
	CalcTitle: computed
});

/** Список */
class ListItem {
	/**
	 * Создание нового жлемента списка
	 * @param {{ Id : number, Value: string }} item элемент списка
	 */
	constructor(item) {
		this.Id = item && item.Id ? item.Id : -1;
		this.Value = item && item.Value ? item.Value : "";
	}

	/**
	 * Сбор данных строки справочника
	 * @param {string} id название поля
	 * @param {string} value значение поля
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Сбор строки справочника для отправки на сервер
	 * @returns {{ Id : number, Value : string }|null}
	 */
	getData() {
		return _.trim(this.Value) === "" ? null : { Id : this.Id, Value : this.Value };
	}
}
decorate(ListItem, {
	Value	: observable, // Значение поля
});


/** ---------- Класс заполнения журналов ---------- */
export class SanJournalFillingState {
	constructor() {
		this.IsSendRequest = false;
		this.Journals = [];
		
		this.ErrorCode = "";
		this.SuccessSave = false;
		this.ButtonLoading = false;
		
		this.Workers = undefined;
		this.Date = undefined;
		this.Invoices = undefined;
		
		this.ProductList = [];
		this.ProviderList = [];
		this.CustomersList = [];
	}

	/** Флаг открытой смены авторизованного пользователя
	 * @returns {boolean} смена пользователя открыта
	 */
	get IsShiftActive () {
		return Boolean(authUserState.User && authUserState.Shift && authUserState.Shift.Active);
	}
	/** Флаг наличия модуля ERP у авторизованного пользователя
	 * @returns {boolean} модуль ERP доступен
	 */
	get HasERP () { return Boolean(authUserState.User && authUserState.HasERP); }

	/** Подготовленный список товаров ERP
	 * @returns {[{ Id: string, Name: string, Type: number }]} товары с типом продукции
	 */
	get Products() { 
		if (_.isEmpty(this.ProductList)) return [];
		return _.map(this.ProductList, (v) => { return { Id: v.Name, Name: v.Name, Type : v.Type } }); 
	}
	/** Подготовленный список поставщиков ERP
	 * @returns {[{ Id: string, Name: string }]} поставщики для выбора
	 */
	get Providers() { 
		if (_.isEmpty(this.ProviderList)) return [];
		return _.map(this.ProviderList, (v) => { return { Id: v.Name, Name: v.Name } });
	}
	/** Подготовленный список клиентов ERP
	 * @returns {[{ Id: string, Name: string }]} клиенты для выбора
	 */
	get Customers() { 
		if (_.isEmpty(this.CustomersList)) return [];
		return _.map(this.CustomersList, (v) => { return { Id: v.Name, Name: v.Name } });
	}

	/** Разбор ответа от сервера с шаблонами журналов для заполнения
	 * @param {object} data ответ от сервера
	 */
	setJournals(data) {
		this.Journals = [];
		if (!_.isUndefined(data) && data.Success && !_.isEmpty(data.Journals)) {
			const journals = _.cloneDeep(data.Journals);
			const groups = [];

			_.each(journals, (journal) => {
				const journalInfo = _.find(JournalsInfo, { Id : journal.TemplateType });
				const isGroup = Boolean(journalInfo && journalInfo.Behaviors && journalInfo.Behaviors.GroupJournals);
				let group = isGroup ? _.find(groups, { TemplateType : journal.TemplateType }) : undefined;

				if (_.isUndefined(group)) {
					group = {
						Name : journal.Name,
						TemplateType : journal.TemplateType,
						Journals : []
					};
					groups.push(group);
				}
				group.Journals.push(journal);
			});

			_.each(groups, (group) => { this.Journals.push(new JournalFill(group, this.HasERP)); });
		}
		this.IsSendRequest = true;
		this.ButtonLoading = false;
	}

	/**
	 * Сбор параметров журнала для сохранения
	 * @returns {{Journals : [object]}}
	 */
	getData () {
		return {
			Journals : _.flatMap(this.Journals, (journal) => journal.getData())
		};
	}

	/** Формирование списка значений по настройкам ERP-справочника поля
	 * @param {[number]} dictionaries типы справочников ERP
	 * @returns {[{ Id: string, Name: string }]} объединенный список значений для выбора
	 */
	getErpDictionary(dictionaries) {
		if (_.isUndefined(dictionaries) || _.isEmpty(dictionaries)) return [];

		const productTypes = _.intersection(dictionaries, [1, 2, 3]);
		const partyTypes = _.intersection(dictionaries, [4, 5]);
		if (!_.isEmpty(productTypes) && !_.isEmpty(partyTypes)) return [];

		if (!_.isEmpty(productTypes)) {
			return _.map(_.filter(this.Products, (product) => _.includes(productTypes, product.Type)), (product) => {
				return { Id : product.Id, Name : product.Name };
			});
		}

		return _.concat(
			_.includes(partyTypes, 4) ? this.Providers : [],
			_.includes(partyTypes, 5) ? this.Customers : []
		);
	}

	/**
	 * Открытие окна с выбором сотрудников для гигиенического журнала
	 * @param {number} id ID журнала
	 */
	openWorkers(id) {
		if (!_.isUndefined(id)) { 
			var journal = this.Journals[id];
			this.Workers = new ShiftWorkers(id, journal.Name, journal.WorkersList); 
		} else this.Workers = undefined
	}

	/**
	 * Открытие окна с выбором даты для журналов с полным списком заполнения
	 * @param {number} id ID журнала
	 */
	openDate(id) {
		if (!_.isUndefined(id)) { 
			var journal = this.Journals[id];
			this.Date = new JournalDate(id, journal.Name, journal.DateType); 
		} else this.Date = undefined
	}

	/** Открытие и закрытие окна выбора накладной
	 * @param {number} id индекс журнала
	 */
	openInvoices (id) {
		if (!_.isUndefined(id)) {
			const journal = this.Journals[id];
			this.Invoices = new SJInvoiceModal(id, journal.Name, journal.InvoiceNumbers);
		} else this.Invoices = undefined;
	}
}
decorate(SanJournalFillingState, {
	IsSendRequest: observable,
	Journals: observable,
	
	ErrorCode: observable,
	SuccessSave: observable,
	ButtonLoading: observable,
	
	Workers: observable,
	Date: observable,
	Invoices: observable,
	
	ProductList: observable,
	ProviderList: observable,
	CustomersList: observable,
	
	IsShiftActive: computed,
	HasERP: computed,
	
	Products: computed,
	Providers: computed,
	Customers: computed,
});
/** Заполняемый журнал */
class JournalFill {
	constructor(group, hasERP = false) {
		this.Journals = group && group.Journals ? group.Journals : [];
		const journal = this.Journals[0] || {};

		this.Name = group && group.Name ? group.Name : "";
		this.TemplateType = group && group.TemplateType ? group.TemplateType : -1;
		
		this.Id = journal && journal.Id ? journal.Id : -1;
		
		this.HasERP = hasERP;

		this.Rows = [];
		this.ClearedJournalIds = [];
		this.RowFieldsTemplate = [];
		_.each(this.Journals, (item) => {
			if (_.isUndefined(item.Items) || _.isEmpty(item.Items)) return;

			const items = _.sortBy(_.filter(item.Items, (row) => !_.isEmpty(row)), (v) => { return v[0].GroupId; });
			_.each(items, (row) => {
				this.Rows.push(new SJRow(row, row[0].GroupId, this.HasERP, item.Id, item.AddName));
			});

			if (_.isEmpty(this.RowFieldsTemplate) && !_.isEmpty(items)) {
				this.RowFieldsTemplate = _.map(items[0], (field) => ({
					...field,
					Id : -1,
					Value : null
				}));
			}
		});
	}

	/** Нетиповые сценарии текущего шаблона */
	get Behaviors () { return this.JournalInfo ? this.JournalInfo.Behaviors : undefined; }
	/** Журнал поддерживает пакетный выбор сотрудников */
	get IsHygiene () { return Boolean(this.Behaviors && this.Behaviors.Workers); }
	/** Журнал поддерживает заполнение из накладных */
	get IsInvoiceJournal () { return Boolean(this.Behaviors && this.Behaviors.Invoices); }
	/** Журналы одного шаблона отображаются общей группой */
	get IsJournalGroup () { return Boolean(this.Behaviors && this.Behaviors.GroupJournals); }

	get DateType () { 
		var dateField = _.find(this.RowFieldsTemplate, (v) => { return v.Type === 4 || v.Type === 6; })
		return dateField ? dateField.Type : 4;
	}
	
	get JournalInfo () { return this.TemplateType ? _.find(JournalsInfo, { Id : this.TemplateType }) : undefined }
	/** Инструкция по заполнению журнала
	 * @returns {string} инструкция
	 */
	get Description () { return this.JournalInfo ? this.JournalInfo.Description : ""; }
	/** Верстка для столбцов по стилю журнала
	 * @returns {string} шаблон верстки
	 */
	get RowClass () {
		if (uistate.IsMobile) return "auto 25px";
		if (_.isUndefined(this.JournalInfo) || _.isUndefined(this.JournalInfo.FillingTemplate)) return "45% auto 25px";

		return uistate.IsTablet && this.JournalInfo.FillingTemplate.Tablet ? this.JournalInfo.FillingTemplate.Tablet 
			: this.JournalInfo.FillingTemplate.Desktop ? this.JournalInfo.FillingTemplate.Desktop : "45% auto 25px";
	}

	/** Получает список значений для полного заполнения
	 * @returns {[{ Id : number, Value : string }]}
	 */
	get MultiList () {
		if (_.isUndefined(this.Rows) || _.isEmpty(this.Rows) || _.isEmpty(this.Rows[0].Fields)) return [];
		var field = _.find(this.Rows[0].Fields, { Type : 9 });

		return !_.isUndefined(field) ? field.Values : [];
	}
	/**
	 * Список сотрудников для гигиенического журнала
	 * @returns {[{ Id : number, Value : string }]}
	 */
	get WorkersList () {
		const fields = this.Behaviors ? this.Behaviors.Workers : undefined;
		if (!this.IsHygiene || _.isUndefined(fields) || _.isEmpty(this.Rows)
			|| !this.Rows[0].Fields[fields.Worker]) return [];
		return this.Rows[0].Fields[fields.Worker].Values || [];
	}

	/** Номера накладных, уже присутствующие в строках журнала
	 * @returns {[string]} номера накладных с типом
	 */
	get InvoiceNumbers () {
		const fields = this.Behaviors ? this.Behaviors.Invoices : undefined;
		if (!this.IsInvoiceJournal || _.isUndefined(fields)) return [];

		return _.compact(_.map(this.Rows, (row) => {
			const field = fields.InvoiceNumber < row.Fields.length ? row.Fields[fields.InvoiceNumber] : undefined;
			return field ? field.Value : null;
		}));
	}

	/** Флаг, что журнал был изменен 
	 * @returns {boolean}
	 */
	get HasChanged () { return !_.isEmpty(this.ClearedJournalIds) || _.some(this.Rows, "HasChanged"); }
	/** Флаг необходимости подтверждения журнала
	 * @returns {boolean}
	 */
	get NeedAccept () { return _.some(this.Rows, "NeedAccept"); }

	/** Добавление одной строки в обычный журнал */
	addRow() {
		this.Rows.push(new SJRow(this.RowFieldsTemplate, -1, this.HasERP, this.Id, this.AddName));
	}

	/** Добавление строк по полному списку
	 * @param {string} date общая дата новых строк
	 */
	addMultiRows(date) {
		const fields = this.Rows[0] ? this.Rows[0].Fields : [];
		if (_.some(fields, { Type : 9 }) && _.isEmpty(this.MultiList)) return;

		_.each(this.MultiList, (item) => {
			let row = _.map(this.RowFieldsTemplate, (field) => {
				return _.extend(_.clone(field), { 
					Value : field.Type === 9 ? item.Id : _.indexOf([4,6], field.Type) !== -1 
						? !_.isUndefined(date) ? date : field.Value : null });
			});
			this.Rows.push(new SJRow(row, -1, this.HasERP, this.Id, this.AddName));
		});
	}

	/** Добавление по одной строке для каждого журнала группы
	 * @param {string} date общая дата новых строк
	 */
	addGroupRows(date) {
		_.each(_.sortBy(this.Journals, "AddName"), (journal) => {
			const sourceRow = _.find(journal.Items, (row) => !_.isEmpty(row));
			if (_.isUndefined(sourceRow)) return;

			const row = _.map(sourceRow, (field) => ({
				...field,
				Id : -1,
				Value : _.includes([4, 6], field.Type) ? date : null
			}));
			this.Rows.push(new SJRow(row, -1, this.HasERP, journal.Id, journal.AddName));
		});
	}

	/**
	 * Добавление строк с выбранными сотрудниками на смене
	 * @param {[number]} workers ID выбранных сотрудников
	 * @param {string} date дата заполнения журнала
	 * @returns {number|undefined} индекс первой добавленной строки
	 */
	addWorkerRows (workers, date) {
		const fields = this.Behaviors ? this.Behaviors.Workers : undefined;
		if (_.isUndefined(fields)) return;
		if (!_.some(this.Rows, { HasChanged : true })) this.Rows = [];
		const firstRow = this.Rows.length;

		_.each(workers, (worker) => {
			let row = _.map(this.RowFieldsTemplate, (field, i) => {
				return _.extend(_.clone(field), {
					Value : i === fields.Date ? date : i === fields.Worker ? worker : null,
					HasChanged : true
				});
			});
			this.Rows.push(new SJRow(row, -1, this.HasERP, this.Id, this.AddName));
		});

		if (_.isEmpty(this.Rows))
			this.Rows.push(new SJRow(this.RowFieldsTemplate, -1, this.HasERP, this.Id, this.AddName));
		return !_.isEmpty(workers) ? firstRow : undefined;
	}

	/** Заполнение строк журнала товарами выбранной накладной
	 * @param {{InvoiceType:number, InvoiceNumber:string, Date:string, Provider:string, Products:[object]}} invoice накладная
	 * @returns {number|undefined} индекс первой добавленной строки
	 */
	addInvoiceRows (invoice) {
		const fields = this.Behaviors ? this.Behaviors.Invoices : undefined;
		
		if (!this.IsInvoiceJournal || _.isUndefined(fields) || _.isUndefined(invoice) || _.isEmpty(invoice.Products)
			|| _.includes(this.InvoiceNumbers, invoice.Title)) return;

		this.Rows = _.filter(this.Rows, (row) => row.HasChanged);
		const firstRow = this.Rows.length;
		_.each(invoice.Products, (product) => {
			const values = {
				[fields.Date] : invoice.Date,
				[fields.Product] : product.ProductName || product.Product,
				[fields.Count] : product.Count,
				[fields.Provider] : invoice.Provider,
				[fields.InvoiceNumber] : invoice.Title
			};
			const row = _.map(this.RowFieldsTemplate, (field, index) => ({
				...field,
				Value : _.has(values, index) ? values[index] : field.Value,
				HasChanged : true
			}));
			this.Rows.push(new SJRow(row, -1, this.HasERP, this.Id, this.AddName));
		});
		return firstRow;
	}

	/**
	 * Проверка возможности удаления строки. Последнюю пустую строку удалить нельзя,
	 * а последнюю сохранённую можно очистить с последующим удалением на сервере.
	 * @param {number} rowIndex индекс строки
	 * @returns {boolean}
	 */
	canDeleteRow(rowIndex) {
		const row = this.Rows[rowIndex];
		if (_.isUndefined(row)) return false;

		return row.IsSaved || _.filter(this.Rows, { JournalId : row.JournalId }).length > 1;
	}

	/**
	 * Создание пустого шаблона из строки конкретного журнала группы.
	 * @param {SJRow} row исходная строка
	 * @returns {[object]} поля новой строки
	 */
	getEmptyRowFields(row) {
		return _.map(row.Fields, (field) => ({
			Id : -1,
			FieldId : field.FieldId,
			Name : field.Name,
			Type : field.Type,
			Value : null,
			Values : _.cloneDeep(field.Values),
			ErpDictionary : _.cloneDeep(field.ErpDictionary),
			DefaultValue : _.cloneDeep(field.DefaultValue)
		}));
	}

	/**
	 * Удаление строки журнала по индексу. Если удалена последняя сохранённая строка
	 * конкретного журнала, на её месте остаётся пустая строка для дальнейшего заполнения.
	 * @param {number} rowIndex индекс строки
	 */
	deleteRow(rowIndex) {
		if (!this.canDeleteRow(rowIndex)) return;

		const row = this.Rows[rowIndex];
		const rows = _.filter(this.Rows, (value, index) => index !== rowIndex);
		const journalRows = _.filter(rows, { JournalId : row.JournalId });

		if (row.IsSaved && !_.some(journalRows, "IsSaved"))
			this.ClearedJournalIds = _.union(this.ClearedJournalIds, [row.JournalId]);

		if (_.isEmpty(journalRows)) {
			rows.splice(rowIndex, 0, new SJRow(
				this.getEmptyRowFields(row), -1, this.HasERP, row.JournalId, row.AddName
			));
		}

		this.Rows = rows;
	}


	/** Подтверждение предзаполненных строк */
	acceptRows () {
		this.Rows = _.map(this.Rows, (row) => {
			return _.extend(row, { 
				Fields : _.map(row.Fields, (field) => { return _.extend(field, { HasChanged : true }) })
			})
		})
	}

	/**
	 * Сбор параметров журнала для сохранения
	 * @returns {[{ Id: number, Lines : [{ GroupId : number, Items : [{ Id : number, FieldId : number, Value : any}]}]}]}
	 */
	getData () {
		const rows = _.compact(_.map(this.Rows, (row) => row.getData()));
		const journals = _.map(_.groupBy(rows, "JournalId"), (journalRows, journalId) => ({
			Id : Number(journalId),
			Lines : _.map(journalRows, "Line")
		}));

		_.each(this.ClearedJournalIds, (journalId) => {
			if (!_.some(journals, { Id : journalId })) journals.push({ Id : journalId, Lines : [] });
		});

		return journals;
	}
}
decorate(JournalFill, {
	Rows: observable,
	ClearedJournalIds: observable,
	Behaviors : computed,
	IsHygiene : computed,
	IsInvoiceJournal : computed,
	IsJournalGroup : computed,
	HasChanged : computed,
	NeedAccept : computed,
	InvoiceNumbers : computed
})

/** Строка журнала */
class SJRow {
	constructor(row, id = -1, hasERP = false, journalId = -1, addName = "") {
		this.GroupId = id;
		this.JournalId = journalId;
		this.AddName = addName || "";
		
		this.Fields = [];
		if (!_.isUndefined(row) && !_.isEmpty(row))
			_.each(row, (field) => { this.Fields.push(new SJField(field, hasERP)); });
	}

	/** Флаг изменения строки 
	 * @returns {boolean}
	*/
	get HasChanged () { return _.some(this.Fields, "HasChanged" ) }
	/** Строка уже сохранена на сервере */
	get IsSaved () { return _.some(this.Fields, (field) => field.Id > 0); }
	/** Флаг необхоидмости подтверждения данных строки 
	 * @returns {boolean}
	*/
	get NeedAccept () {
		return !this.HasChanged && _.every(this.Fields, (f) => { return f.Type === 10 || f.NeedAccept; })
	}

	/**
	 * Сбор полной строки и ID журнала-владельца для формирования payload.
	 * @returns {{ JournalId: number, Line: { GroupId: number, Items: Array<{ Id: number, FieldId: number, Value: any }> } }|null} строка журнала
	 */
	getData() {
		if (!this.HasChanged) return null;
		return {
			JournalId : this.JournalId,
			Line : {
				GroupId : this.GroupId,
				Items : _.compact(_.map(this.Fields, (field) => field.getData()))
			}
		};
	}
}
decorate(SJRow, {
	Fields : observable,
	HasChanged : computed,
	IsSaved : computed,
	NeedAccept : computed
})

/** Поле журнала */
class SJField {
	/**
	 * Пустые поля типа 4 заполняются текущей датой, типа 6 — текущими датой и временем,
	 * в том числе в уже существующих строках журнала.
	 * Поля типа 5 автоматически не заполняются. 
	 * Значение, полученное от сервера, имеет приоритет,
	 * а автоподстановка не отмечает поле изменённым.
	 *
	 * Разбор ответа от сервера с шаблонами журналов для заполнения
	 * @param {object} data ответ от сервера
	 */
	constructor(field, hasERP = false) {
		this.FieldId = field && field.FieldId ? field.FieldId : -1;
		this.Id = field && field.Id ? field.Id : -1;
		this.Name = field && field.Name ? field.Name : "";
		this.Type = field && field.Type ? field.Type : -1;
		this.Values = field && field.Values ? field.Values : [];
		this.ErpDictionary = field && _.isArray(field.ErpDictionary) ? field.ErpDictionary : [];
		this.DefaultValue = field && field.DefaultValue ? field.DefaultValue : null;
		
		this.Value = field && !_.isUndefined(field.Value) ? !_.isNull(field.Value) ? field.Value :
			this.CanUseDefaultValue ? this.DefaultValue.Value :
			this.CanUseDefaultRange ? getRandomRangeValue(this.DefaultValue.Min, this.DefaultValue.Max, this.DefaultValue.Step) :
			this.IsDate ? formatDate("today", this.Type === 6 ? "rtime" : "r") : 
			field.Type === 8 && field.Values.length === 1 ? field.Values[0].Id :
			field.Type === 7 ? !_.isBoolean(field.Value) ? field.Value : false :
			field.Value : null;

		this.HasChanged = (field && field.HasChanged) || this.Id > 0;
		this.HasERP = hasERP;
	}

	/** Флаг возможности использовать ERP-справочник для поля
	 * @returns {boolean} ERP доступна, поле строковое и для него настроен справочник
	 */
	get CanUseERP () { return this.HasERP && this.Type === 1 && !_.isEmpty(this.ErpDictionary);  }
	/** Настройки текущего типа поля */
	get TypeSettings () { return _.find(SanJournalFieldTypes, { Id : this.Type }); }
	get CanDefault () { return !_.isUndefined(this.TypeSettings) && this.TypeSettings.CanDefault
		&& !_.isUndefined(this.DefaultValue) && !_.isNull(this.DefaultValue)
	}
	get CanUseDefaultValue () { return this.CanDefault && !_.isUndefined(this.DefaultValue.Value)
		&& !_.isNull(this.DefaultValue.Value) && this.DefaultValue.Value !== "";
	}
	get CanUseDefaultRange () { return this.CanDefault && this.IsNumber && !this.CanUseDefaultValue 
		&& !_.isUndefined(this.DefaultValue.Min) && !_.isNull(this.DefaultValue.Min) && this.DefaultValue.Min !== ""
		&& _.includes(this.TypeSettings.Step, this.DefaultValue.Step)
	}

	get IsNumber () { return this.Type === 2 || this.Type === 3; }
	get IsDate () { return this.Type === 4 || this.Type === 6; }


	get NeedAccept () {
		return this.Id === -1 && !_.isNull(this.Value) && !_.isUndefined(this.Value) && this.Value !== "" && !this.HasChanged;
	}

	/** Строковое значение для предзаполненных списков 
	 * @returns {string}
	*/
	get ValueTitle () {
		if (this.Type !== 9) return "";
		
		var value = _.find(this.Values, { Id : this.Value});
		return value ? value.Value : "";
	}

	/** Изменение значения поля 
	 * @param {string|number|boolean} value новое значение поля
	 */
	collect(value) {
		this.Value = value;
		this.HasChanged = true;
	}

	/**
	 * Сбор поля для полного payload строки.
	 * Пример результата: { Id: -1, FieldId: 12, Value: "Значение" }.
	 * @returns {{ Id: number, FieldId: number, Value: any }} поле строки
	 */
	getData() {
		return {
			Id : this.Id,
			FieldId : this.FieldId,
			Value : this.Value === -1 || this.Value === "" ? null : this.Value
		};
	}
}

decorate(SJField, {
	Value : observable,
	HasChanged : observable,

	TypeSettings : computed,
	CanDefault: computed,
	CanUseDefaultValue: computed,
	CanUseDefaultRange: computed,
	CanUseERP : computed,
	NeedAccept : computed
})

/** Сотрудники на смене */
class ShiftWorkers {
	constructor(journal = -1, name = "", workers = []) {
		this.Journal = journal;
		this.Name = name;
		this.Workers = workers;
		this.Date = formatDate("today", "r")
		this.Checked = [];
	}

	/**
	 * Сбор данных с формы выбора сотрудников на смене
	 * @param {string} id название параметра
	 * @param {boolean} value значение параметра
	 */
	collect(id, value) {
		if (/Date/.test(id)) this.Date = value;
		else  {
			var index = id.split("_")[1] ? parseInt(id.split("_")[1], 10) : undefined;
			this.Checked = collectCheckBox(index, value, this.Checked)
		}
	}
}
decorate(ShiftWorkers, {
	Checked: observable,
	Date: observable
})

/** Общая дата журнала */
class JournalDate {
	constructor(journal = -1, name = "", type = 4) {
		this.Journal = journal;
		this.Name = name;
		this.Type = type;
		this.Date = formatDate("today", type === 6 ? "rtime" : "r");
	}

	/**
	 * Сбор данных с формы выбора общей даты журнала
	 * @param {string} id название параметра
	 * @param {string} value выбранная дата
	 */
	collect(id, value) { this[id] = value; }
}
decorate(JournalDate, {
	Date: observable
})


/** Состояние окна выбора накладной */
class SJInvoiceModal {
	constructor(journal = -1, name = "", invoices = []) {
		this.Journal = journal;
		this.Name = name;
		this.Checked = invoices;

		// TODO lобавить в фильтр филиал айди
		this.Filter = {
			FilialId : authUserState.Shift.FilialId,
			Limit : 10,
			Offset : 0
		}

		this.HasMore = false;
		this.List = [];

		this.ErrorCode = "";
		this.IsSendRequest = false;
		this.Loading = false;
	}

	/** Разбор страницы списка накладных
	 * @param {object} data ответ API списка накладных
	 */
	setInvoices (data) {
		this.ErrorCode = data && data.Success ? "" : data && data.ErrorCode ? data.ErrorCode : "";
		this.List = data && data.Success && !_.isNull(data.Invoices) ? 
			_.map(data.Invoices, (item) => {
				var type = _.find(InvoiceTypes, { Id : item.InvoiceType }),
					title = (type ? type.ShortName + " " : "") + (item.InvoiceNumber || "")
				return {
					...item, 
					Date : formatDate(item.Date),
					Disabled : _.indexOf(this.Checked, title) !== -1,
					Title : title
				}
				}) : [];
		this.HasMore = Boolean(data && data.Success && data.HasMore);
		this.IsSendRequest = true;
	}
}
decorate(SJInvoiceModal, { 
	ErrorCode : observable, 
	Filter: observable,
	HasMore: observable,
	List: observable,
	IsSendRequest: observable,
	Loading: observable
});


/** ---------- Класс отчетов по СЖ ---------- */
export class SJReportState { 
	constructor() {
		this.Filter = new SJFilter();
		this.IsSendRequest = false;
		this.Report = [];

		this.JournalsList = [];
	}

	/**
	 * Получение доступных пользователю филиалов.
	 * @returns {[{ Id : number, Name : string }]} филиалы для фильтра отчёта
	 */
	get Filials () {
		if (_.isUndefined(authUserState) || _.isEmpty(authUserState.Filials)) return [];

		return _.map(authUserState.Filials, (filial) => ({ Id : filial.Id, Name : filial.Name }));
	}

	/**
	 * Формирование списка доступных шаблонов журналов для фильтра
	 * @returns {{ Id : number, Name: string }} список уникальных шаблонов СЖ
	 */
	get Journals() {
		if (_.isUndefined(this.JournalsList) || _.isEmpty(this.JournalsList)) return [];
		return _.uniqBy(_.map(this.JournalsList, (journal) => {
			return {
				Id : journal.TemplateType,
				Name : journal.Name
			}
		}), "Id");
	}

	/**
	 * Разбор ответа отчёта с объединением журналов, для которых включено групповое отображение.
	 * Группы формируются по типу шаблона и филиалу, сохраняя позицию первого журнала.
	 * @param {object} data 
	 */
	setReport(data) {
		this.Report = [];
		if (data.Success) {
			const groups = {};

			_.each(data.Journals, (item) => {
				const journal = new SJReportJournal(item);

				if (journal.Behaviors && journal.Behaviors.GroupJournals) {
					const key = journal.TemplateType + "_" + journal.FilialId;

					if (_.isUndefined(groups[key])) {
						groups[key] = new SJReportJournalGroup(journal);
						this.Report.push(groups[key]);
					} else groups[key].addJournal(journal);
				} else this.Report.push(journal);
			});

			_.each(groups, (group) => { group.sortJournals(); });
		}
		this.IsSendRequest = true;
	}
}
decorate(SJReportState, {
	IsSendRequest: observable,	// Флаг отправки запроса
	Filter: observable,			// Объект фильтра отчета
	JournalsList: observable,	// Список шаблонов журналов
	Report: observable,			// Отчет по СЖ
	Filials: computed,			// Доступные пользователю филиалы
	Journals: computed
});

class SJFilter {
	constructor() {
		this.DateFrom = formatDate(moment().subtract(1, "M"), "r");
		this.DateTo = formatDate("today", "r");
		this.FilialId = -1;
		this.JournalType = -1;
	}

	/**
	 * Сбор данных с формы поиска 
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Сбор параметров фильтра для отправки на сервер
	 * @returns {{ DateFrom : "YYYY-MM-DD", DateTo : "YYYY-MM-DD", FilialId : number, JournalType : number}}
	 */
	getData() {
		return {
			DateFrom : this.DateFrom,
			DateTo : this.DateTo,
			FilialId : this.FilialId,
			JournalType : this.JournalType
		}
	}

	/** Сбор данных для отправки запроса получения журнала 
	 * @param {number} id ID журнала
	 * @returns {{ DateFrom : "YYYY-MM-DD", DateTo : "YYYY-MM-DD", JournalId : number }}
	 */
	getItem(id) { 
		return {
			DateFrom : this.DateFrom,
			DateTo : this.DateTo,
			JournalId : id
		} 
	}
}
decorate(SJFilter, {
	DateFrom: observable,
	DateTo: observable,
	FilialId: observable,
	JournalType: observable
})

export class SJReportJournal {
	constructor(journal) {
		this.Id = journal && journal.Id ? journal.Id : -1;
		this.Filial = journal && journal.Filial ? journal.Filial : "";
		this.FilialId = journal && !_.isUndefined(journal.FilialId) ? journal.FilialId : -1;
		this.TemplateType = journal && journal.TemplateType ? journal.TemplateType : -1;
		this.Name = journal && journal.Name ? journal.Name : "";
		this.RecordsCount = journal && journal.RecordsCount ? journal.RecordsCount : 0;
		this.AddName = journal && journal.AddName ? journal.AddName : "";
		this.StartRemainingWorkMinutes = journal && !_.isUndefined(journal.StartRemainingWorkMinutes) ? journal.StartRemainingWorkMinutes : null;
		this.WorkedMinutes = journal && journal.WorkedMinutes ? journal.WorkedMinutes : null;
	}

	/**
	 * Получение настроек шаблона журнала
	 * @returns {object|undefined} настройки журнала из JournalsInfo
	 */
	get JournalInfo () { return this.TemplateType ? _.find(JournalsInfo, { Id : this.TemplateType }) : undefined }
	/** Нетиповые сценарии текущего шаблона */
	get Behaviors () { return this.JournalInfo ? this.JournalInfo.Behaviors : undefined; }
	/** Обычный журнал не является группой журналов */
	get IsGroup () { return false; }

	/**
	 * Получение описания журнала
	 * @returns {string} описание журнала
	 */
	get Description () { return this.JournalInfo ? this.JournalInfo.Description : ""; }

	/**
	 * Получение шаблона колонок подробного отчёта
	 * @returns {string} CSS-шаблон колонок для текущего устройства
	 */
	get Template () { 
		if (_.isUndefined(this.TemplateType) || _.isUndefined(this.JournalInfo) 
			|| _.isUndefined(this.JournalInfo.ReportTemplate) 
			|| _.isUndefined(this.JournalInfo.ReportTemplate.Desktop)
		) return "150px auto 250px";
		var template = this.JournalInfo.ReportTemplate;

		return uistate.isDevice && !_.isUndefined(template.Device) ? template.Device : template.Desktop;
	}

	/**
	 * Проверка необходимости группировки строк отчёта по дате
	 * @returns {boolean} флаг группировки строк по ReportDate
	 */
	get IsDateGroup () { return Boolean(this.Behaviors && this.Behaviors.ReportGroupByDate); }

	/**
	 * Формирование строки с ответственным за заполнение журнала
	 * @returns {string} ответственный пользователь или должность и филиал
	 */
	get Responsible () { 
		if (_.isUndefined(this.User) && _.isUndefined(this.Role)) return "Ответственный за заполнение журнала";
		return "Ответственный за заполнение журнала: " + (this.User || this.Role) + " в филиале " + this.Filial; 
	}

	/**
	 * Расчёт оставшегося времени работы установки
	 * @returns {number|null} остаток работы в минутах
	 */
	get RemainingMinutes () { 
		return !_.isNull(this.StartRemainingWorkMinutes) ? this.StartRemainingWorkMinutes - (this.WorkedMinutes || 0) : null;
	}

	/**
	 * Форматирование оставшегося времени работы установки
	 * @returns {string|null} остаток работы в часах и минутах
	 */
	get RemainingTime () {
		if (_.isNull(this.RemainingMinutes)) return null;

		var minutes = Math.abs(this.RemainingMinutes),
			sign = this.RemainingMinutes < 0 ? "−" : "",
			hours = Math.floor(minutes / 60),
			minutesRest = minutes % 60;

		return sign + hours + " ч " + minutesRest + " м";
	}

	/**
	 * Определение состояния остатка времени по порогам текущего типа журнала
	 * @returns {string} red при исчерпанном времени, orange при достижении критического порога,
	 * yellow при достижении предупреждающего порога или пустая строка без состояния
	 */
	get RemainingState () {
		if (_.isNull(this.RemainingMinutes)) return "";
		if (this.RemainingMinutes <= 0) return "red";
		if (_.isUndefined(this.JournalInfo) || _.isUndefined(this.JournalInfo.RemainingWorkLimits)) return "";
		if (this.JournalInfo.RemainingWorkLimits.Critical && this.RemainingMinutes <= this.JournalInfo.RemainingWorkLimits.Critical) return "orange";
		if (this.JournalInfo.RemainingWorkLimits.Warning && this.RemainingMinutes <= this.JournalInfo.RemainingWorkLimits.Warning) return "yellow";

		return "";
	}

	setJournal(journal) {
		this.User = journal && journal.User ? journal.User : "";
		this.Role = journal && journal.Role ? journal.Role : "";
		this.Fields = !_.isEmpty(journal.Items) ? _.map(journal.Items[0].Fields, "Name") : [];

		var items = !_.isEmpty(journal.Items) ? _.map(journal.Items, (row) => {
			return _.extend(row, {
				Date : formatDate(moment(row.Date), "datetime"),
				Fields : _.map(row.Fields, (item) => {
					return _.extend(item, {
						Value: 	item.Type === 4 ? formatDate(item.Value) : 
								item.Type === 6 ? formatDate(item.Value, "datetime") : 
								item.Type === 7 ? item.Value === true ? "Да" : "Нет" :
								item.Value,
						NotFilling : item.Type !== 7 && _.isNull(item.Value)
					})
				})
			})
		}) : [];

		if (this.IsDateGroup)
			this.Rows = _.orderBy(_.map(_.groupBy(items, "ReportDate"), (group, date) => {
				return {
					ReportDate : date,
					Date : formatDate(date),
					Items : group
				}
			}), ["ReportDate"], ["desc"])
		else
			this.Rows = _.orderBy(items, ["ReportDate"], ["desc"]);
	}
}
decorate(SJReportJournal, {
	Fields: observable,
	Rows: observable,
	User: observable,
	Role: observable,
	JournalInfo: computed,
	Behaviors: computed,
	IsGroup: computed,
	Description: computed,
	Template: computed,
	IsDateGroup: computed,
	Responsible: computed,
	RemainingMinutes: computed,
	RemainingTime: computed,
	RemainingState: computed
})

/** Группа однотипных установок одного филиала в списке отчётов */
class SJReportJournalGroup {
	constructor(journal) {
		this.TemplateType = journal.TemplateType;
		this.Name = journal.Name;
		this.Filial = journal.Filial;
		this.FilialId = journal.FilialId;
		this.RecordsCount = 0;
		this.Journals = [];
		this.addJournal(journal);
	}

	/** Групповая строка всегда раскрывается локально без запроса отчёта */
	get IsGroup () { return true; }
	/** На уровне группы остаток времени не суммируется и не отображается */
	get RemainingTime () { return null; }

	/** Добавление установки и её количества записей в итог группы */
	addJournal(journal) {
		this.Journals.push(journal);
		this.RecordsCount += journal.RecordsCount;
	}

	/** Сортировка установок внутри группы по дополнительному названию */
	sortJournals() { this.Journals = _.sortBy(this.Journals, "AddName"); }
}
decorate(SJReportJournalGroup, {
	Journals: observable,
	RecordsCount: observable,
	IsGroup: computed,
	RemainingTime: computed
})
